import {
  type InferOutput,
  maxLength,
  nonEmpty,
  object,
  picklist,
  pipe,
  string,
  trim,
} from "valibot";

import type { LabelColor } from "./types";

export const LabelSchema = object({
  name: pipe(
    string(),
    trim(),
    nonEmpty("Label name is required"),
    maxLength(255, "Label name can't be more than 255 characters long"),
  ),
  color: picklist<LabelColor[], string>(
    [
      "yellow",
      "quaternary",
      "info",
      "secondary",
      "success",
      "danger",
      "orange",
      "magenta",
    ],
    "Invalid Color",
  ),
});
export type LabelSchemaType = InferOutput<typeof LabelSchema>;
